import { render, staticRenderFns } from "./SingleMessage.vue?vue&type=template&id=ced67b98&scoped=true&"
import script from "./SingleMessage.vue?vue&type=script&lang=js&"
export * from "./SingleMessage.vue?vue&type=script&lang=js&"
import style0 from "./SingleMessage.vue?vue&type=style&index=0&id=ced67b98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced67b98",
  null
  
)

export default component.exports